import { observable, autoinject, bindable, bindingMode, containerless, customElement } from "aurelia-framework";
import nameof from "../../../common/nameof";
import "./filter-menu-more-button.scss";

@autoinject
@containerless
@customElement("filter-menu-more-button")
export class FilterMenuMoreButton {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public navItem: HTMLElement[];
    @bindable({ defaultBindingMode: bindingMode.toView })
    public menuContainer: HTMLElement;
    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public activeItem: HTMLElement;
    @bindable({ defaultBindingMode: bindingMode.toView })
    @observable({ changeHandler: nameof<FilterMenuMoreButton>("tabsChanged") })
    public tabs: any[];
    public activeSubMenuItem: number;
    public showMoreButton: HTMLElement;

    public attached() {
        if (this.menuContainer) {
            setTimeout(() => this.overflowAdjust(), 250);
            this.handleOverflow();
            $(".secondary-menu-item").on("click", (e) => {
                let id = Number(e.currentTarget?.getAttribute("id"));
                this.activeSubMenuItem = id;
                this.activeItem = this.navItem[id];
                this.overflowAdjust();
            });
        }
    }

    private handleOverflow() {
        let timeout: NodeJS.Timer = null;
        window.addEventListener("resize", () => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() =>
                this.overflowAdjust(), 100);
        });
    }

    private getElementProperty(item: HTMLElement, property: string) {
        if (!item) {
            return 0;
        }
        const style = document.defaultView.getComputedStyle(item);
        const left = style?.getPropertyValue(`${property}-left`);
        const right = style?.getPropertyValue(`${property}-right`);
        return Number(left.replace(/px$/, "")) + Number(right.replace(/px$/, ""));
    }

    private overflowAdjust() {
        const navBar = this.menuContainer;
        let navItems = Array.from(navBar.querySelectorAll("ul > li:not(.show-more-button)"));
        let moreButtonItems = Array.from(navBar.getElementsByClassName("secondary-menu-item"));
        const moreButton = this.showMoreButton;
        const allHiddenItems = Array.from(navBar.getElementsByClassName("hidden"));
        allHiddenItems.forEach((item) => {
            item.classList.remove("hidden");
        });
        let stopWidth = moreButton?.offsetWidth + this.getElementProperty(moreButton, "margin");
        let hiddenItems: number[] = [];
        const navWidth = navBar.clientWidth - this.getElementProperty(navBar, "padding");
        if (!this.activeSubMenuItem) {
            this.activeSubMenuItem = navItems.findIndex((item) => item.classList.contains("active"));
        }
        // Filter out active menu item
        moreButtonItems[this.activeSubMenuItem]?.classList.add("hidden");
        let activeTab = navItems[this.activeSubMenuItem] as HTMLElement;
        stopWidth += activeTab ? activeTab.offsetWidth + this.getElementProperty(activeTab, "margin") : 0;
        moreButtonItems = moreButtonItems.filter((item, index) => index !== this.activeSubMenuItem);
        navItems = navItems.filter((item, index) => index !== this.activeSubMenuItem);
        // Hide nav items depending on width
        navItems.forEach((navItem, i) => {
            let item = navItem as HTMLElement;
            const itemWidth = item.offsetWidth + this.getElementProperty(item, "margin");
            if (navWidth >= stopWidth + itemWidth) {
                stopWidth += itemWidth;
            } else {
                item.classList.add("hidden");
                hiddenItems.push(i);
            }
        });
        if (!hiddenItems.length) {
            moreButton.classList.add("hidden");
        } else {
            moreButtonItems.forEach((item, i) => {
                if (!hiddenItems.includes(i)) {
                    item.classList.add("hidden");
                }
            });
        }
    }

    public tabsChanged() {
        this.overflowAdjust();
    }

}